// HKDSE 2022 Paper 1 Knowledge Graph Samples - Part 3
// Advanced questions from the complete 2022 paper

export const hkdse2022Samples_part3 = {
  statistics_advanced: [
    {
      id: 'hkdse2022_statistics_02',
      problem: "下面的幹葉圖顯示某足球隊球員的年齡的分佈。該分佈的四分位數間距及中位數分別為 $14$ 及 $31$。(a) 求 $a$ 及 $b$。(b) 某球員現退出該足球隊。(i) 該分佈的眾數有否因該球員退出而改變？試解釋你的答案。(ii) 若該分佈的分佈域減小，求該分佈的最大可取標準差。",
      problemType: "statistics_stem_leaf",
      difficulty: "harder",
      description: "Advanced statistics with stem-and-leaf plots",
      graphData: {
        nodes: [
          {
            id: "stem_leaf_plot",
            name: "Stem-and-Leaf Plot",
            type: "concepts",
            description: "Age distribution with stems and leaves",
            value: "Stem | Leaf format for ages",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "quartile_range",
            name: "Quartile Range",
            type: "concepts",
            description: "IQR = Q3 - Q1 = 14",
            value: "IQR = 14",
            importance: 8,
            x: -150, y: -100, z: 20
          },
          {
            id: "median",
            name: "Median",
            type: "concepts",
            description: "Median = 31",
            value: "Median = 31",
            importance: 8,
            x: 150, y: -100, z: 20
          },
          {
            id: "part_a_find_a_b",
            name: "Part (a): Find a and b",
            type: "steps",
            description: "Use median and IQR to find missing values",
            value: "Use median position and quartile calculations",
            importance: 9,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_a_calculation",
            name: "Part (a): Calculation",
            type: "steps",
            description: "Calculate a and b values",
            value: "a = 2, b = 8",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_b_mode_change",
            name: "Part (b)(i): Mode Change",
            type: "steps",
            description: "Analyze if mode changes when player leaves",
            value: "Mode may or may not change depending on the player's age",
            importance: 8,
            x: -200, y: 150, z: 0
          },
          {
            id: "part_b_range_decrease",
            name: "Part (b)(ii): Range Decrease",
            type: "steps",
            description: "Find maximum standard deviation when range decreases",
            value: "Use range and standard deviation relationship",
            importance: 9,
            x: 200, y: 150, z: 0
          },
          {
            id: "part_b_max_std",
            name: "Part (b)(ii): Max Standard Deviation",
            type: "steps",
            description: "Calculate maximum standard deviation",
            value: "σ_max = √(Σ(x-μ)²/n)",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "All required answers",
            value: "(a) a=2, b=8 (b)(i) May change (b)(ii) σ_max",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "stem_leaf_plot", to: "part_a_find_a_b", type: "enables", strength: 9 },
          { from: "quartile_range", to: "part_a_find_a_b", type: "enables", strength: 8 },
          { from: "median", to: "part_a_find_a_b", type: "enables", strength: 8 },
          { from: "part_a_find_a_b", to: "part_a_calculation", type: "leads to", strength: 9 },
          { from: "part_a_calculation", to: "part_b_mode_change", type: "enables", strength: 8 },
          { from: "part_a_calculation", to: "part_b_range_decrease", type: "enables", strength: 9 },
          { from: "part_b_range_decrease", to: "part_b_max_std", type: "leads to", strength: 9 },
          { from: "part_a_calculation", to: "final_answers", type: "contributes to", strength: 9 },
          { from: "part_b_mode_change", to: "final_answers", type: "contributes to", strength: 8 },
          { from: "part_b_max_std", to: "final_answers", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  circle_geometry: [
    {
      id: 'hkdse2022_circle_01',
      problem: "圖2中，$O$ 是圓心，$A$ 是圓周上的一點，$B$ 是圓外的一點，$C$ 是 $AB$ 的中點，$D$ 是 $OC$ 的中點。已知 $OA = 5$ 及 $AB = 8$。(a) 求 $OC$ 的長度。(b) 求 $OD$ 的長度。(c) 求 $BD$ 的長度。",
      problemType: "circle_geometry",
      difficulty: "intermediate",
      description: "Circle geometry with chords and distances",
      graphData: {
        nodes: [
          {
            id: "circle_properties",
            name: "Circle Properties",
            type: "concepts",
            description: "O is center, A is on circumference, B is outside",
            value: "OA = 5 (radius), AB = 8",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "midpoint_properties",
            name: "Midpoint Properties",
            type: "concepts",
            description: "C is midpoint of AB, D is midpoint of OC",
            value: "AC = CB = 4, OD = DC",
            importance: 8,
            x: -150, y: -100, z: 20
          },
          {
            id: "part_a_oc_length",
            name: "Part (a): OC Length",
            type: "steps",
            description: "Use distance formula or Pythagorean theorem",
            value: "OC = √(OA² - AC²) = √(25 - 16) = 3",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "part_b_od_length",
            name: "Part (b): OD Length",
            type: "steps",
            description: "D is midpoint of OC",
            value: "OD = OC/2 = 3/2 = 1.5",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_c_bd_length",
            name: "Part (c): BD Length",
            type: "steps",
            description: "Use distance formula for BD",
            value: "BD = √(BC² + DC²) = √(16 + 2.25) = √18.25",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "All required lengths",
            value: "(a) 3 (b) 1.5 (c) √18.25",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "circle_properties", to: "part_a_oc_length", type: "enables", strength: 9 },
          { from: "midpoint_properties", to: "part_a_oc_length", type: "enables", strength: 8 },
          { from: "part_a_oc_length", to: "part_b_od_length", type: "enables", strength: 8 },
          { from: "part_a_oc_length", to: "part_c_bd_length", type: "enables", strength: 9 },
          { from: "part_b_od_length", to: "part_c_bd_length", type: "enables", strength: 8 },
          { from: "part_a_oc_length", to: "final_answers", type: "contributes to", strength: 9 },
          { from: "part_b_od_length", to: "final_answers", type: "contributes to", strength: 8 },
          { from: "part_c_bd_length", to: "final_answers", type: "contributes to", strength: 9 }
        ]
      }
    }
  ],
  
  mensuration: [
    {
      id: 'hkdse2022_mensuration_01',
      problem: "圖3中，$ABCD$ 是一個長方形，$E$ 是 $AD$ 上的一點，$F$ 是 $BC$ 上的一點，$G$ 是 $EF$ 上的一點。已知 $AB = 12$，$AD = 8$，$AE = 3$，$BF = 2$ 及 $EG = 4$。(a) 求 $EF$ 的長度。(b) 求 $\\triangle AEG$ 的面積。(c) 求 $\\triangle CGF$ 的面積。",
      problemType: "mensuration_areas",
      difficulty: "intermediate",
      description: "Area calculations in rectangle with points",
      graphData: {
        nodes: [
          {
            id: "rectangle_properties",
            name: "Rectangle Properties",
            type: "concepts",
            description: "ABCD is rectangle with given dimensions",
            value: "AB = 12, AD = 8, AE = 3, BF = 2, EG = 4",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "coordinate_setup",
            name: "Coordinate Setup",
            type: "concepts",
            description: "Set up coordinate system for calculations",
            value: "A(0,0), B(12,0), C(12,8), D(0,8)",
            importance: 8,
            x: -150, y: -100, z: 20
          },
          {
            id: "part_a_ef_length",
            name: "Part (a): EF Length",
            type: "steps",
            description: "Find coordinates of E and F, then EF length",
            value: "E(0,3), F(12,2), EF = √(12² + 1²) = √145",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "part_b_aeg_area",
            name: "Part (b): AEG Area",
            type: "steps",
            description: "Calculate area of triangle AEG",
            value: "Area = (1/2) × base × height = (1/2) × 3 × 4 = 6",
            importance: 8,
            x: 0, y: 0, z: 25
          },
          {
            id: "part_c_cgf_area",
            name: "Part (c): CGF Area",
            type: "steps",
            description: "Calculate area of triangle CGF",
            value: "Area = (1/2) × base × height = (1/2) × 6 × 2 = 6",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "All required measurements",
            value: "(a) √145 (b) 6 (c) 6",
            importance: 10,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          { from: "rectangle_properties", to: "part_a_ef_length", type: "enables", strength: 9 },
          { from: "coordinate_setup", to: "part_a_ef_length", type: "enables", strength: 8 },
          { from: "part_a_ef_length", to: "part_b_aeg_area", type: "enables", strength: 8 },
          { from: "part_a_ef_length", to: "part_c_cgf_area", type: "enables", strength: 8 },
          { from: "part_a_ef_length", to: "final_answers", type: "contributes to", strength: 9 },
          { from: "part_b_aeg_area", to: "final_answers", type: "contributes to", strength: 8 },
          { from: "part_c_cgf_area", to: "final_answers", type: "contributes to", strength: 8 }
        ]
      }
    }
  ]
}; 